import { createUseStyles } from 'react-jss';

import colors from "../../../../utils/colors";

// Props are not used here. This allows you to create a function for multiple style classes and keep the correct styles.
var styles = {
  header: function header() {return {
      margin: '1.5rem 0 0',
      borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
      paddingBottom: '1.5rem'
    };},
  titleButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '1.5rem',
    '& button': {
      padding: 0,
      fontSize: '1.6rem',
      lineHeight: '2.4rem',
      fontWeight: 400
    }
  },

  planDetailsButton: {
    textTransform: 'uppercase',
    paddingLeft: 0,
    font: {
      size: '1.6rem',
      lineHeight: '3rem',
      weight: 400
    },
    zIndex: 5,
    position: 'relative'
  },
  configureButton: {
    textTransform: 'uppercase',
    paddingLeft: 0,
    // Configure icon
    '& span': {
      width: '2rem',
      height: '2rem'
    }
  },
  shortHeader: function shortHeader() {return {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '1.5rem',
      '& button': {
        fontWeight: 400,
        paddingRight: 0
      },
      '& h2': {
        width: 'auto',
        maxWidth: '64%',
        marginRight: '2rem'
      }
    };}
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map